import * as React from 'react'
import type { Editor } from '@tiptap/core'
import {
  Bold,
  Braces,
  Heading2,
  ImagePlus,
  Italic,
  Link2,
  Minus,
  MousePointerClick,
} from 'lucide-react'
import { Button } from '@/components/ui/button'

export type BlastEditorTool = 'link' | 'button' | 'image' | 'mergeField'

export function BlastEditorToolbar({
  editor,
  onOpenTool,
}: {
  editor: Editor
  onOpenTool: (tool: BlastEditorTool) => void
}) {
  return (
    <div className="flex items-center gap-0.5 border-b border-border bg-background px-2 py-1.5">
      <ToolbarButton
        label="Heading"
        active={editor.isActive('heading')}
        onClick={() => editor.chain().focus().toggleHeading({ level: 2 }).run()}
      >
        <Heading2 />
      </ToolbarButton>
      <ToolbarButton
        label="Bold"
        active={editor.isActive('bold')}
        onClick={() => editor.chain().focus().toggleBold().run()}
      >
        <Bold />
      </ToolbarButton>
      <ToolbarButton
        label="Italic"
        active={editor.isActive('italic')}
        onClick={() => editor.chain().focus().toggleItalic().run()}
      >
        <Italic />
      </ToolbarButton>
      <ToolbarButton
        label="Link"
        active={editor.isActive('link')}
        onClick={() => onOpenTool('link')}
      >
        <Link2 />
      </ToolbarButton>
      <ToolbarButton label="Button" onClick={() => onOpenTool('button')}>
        <MousePointerClick />
      </ToolbarButton>
      <ToolbarButton label="Image" onClick={() => onOpenTool('image')}>
        <ImagePlus />
      </ToolbarButton>
      <ToolbarButton label="Merge field" onClick={() => onOpenTool('mergeField')}>
        <Braces />
      </ToolbarButton>
      <ToolbarButton
        label="Divider"
        onClick={() => editor.chain().focus().setHorizontalRule().run()}
      >
        <Minus />
      </ToolbarButton>
    </div>
  )
}

function ToolbarButton({
  label,
  active = false,
  onClick,
  children,
}: {
  label: string
  active?: boolean
  onClick: () => void
  children: React.ReactElement<{ className?: string }>
}) {
  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      className="border-transparent px-2"
      aria-label={label}
      aria-pressed={active}
      onClick={onClick}
    >
      {React.cloneElement(children, { className: 'size-4 text-muted-foreground' })}
    </Button>
  )
}
